export const BOOK_CSS_CANCELLATION_URL = 'https://outlook.office.com/book/BookaCancellationCall@grainfox.ca/?ismsaljsauthenabled';
export const BOOK_CSS_DEMO_URL = 'https://outlook.office.com/book/Sales@grainfox.ca/?ismsaljsauthenabled';
export const BOOK_CSS_MKT_INTEL_URL = 'https://outlook.office.com/book/Sales@grainfox.ca/?ismsaljsauthenabled';
export const BOOK_CSS_MANAGED_PLAN_URL = 'https://outlook.office.com/book/Sales@grainfox.ca/?ismsaljsauthenabled';
export const BOOK_A_MEETING_FEATURE_FLAG = 'book-a-meeting';
export const SEND_CSS_EMAIL_URL = 'mailto:grainfox@farmlinksolutions.ca';
